import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Component({
  selector: 'ml-date-picker',
  template: `
    <mat-form-field color="primary" class="full-width">
      <mat-label *ngIf="label">
        {{ label | translate | titlecase }}
      </mat-label>
      <input
        matInput
        [matDatepicker]="picker"
        [formControl]="control"
        [required]="isRequired"
        [min]="minDate"
        [max]="maxDate"
        placeholder="DD.MM.YYYY"
      />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>

      <mat-error *ngIf="control.hasError('required')">
        {{ 'date' | translate | titlecase }} {{ 'is-required' | translate }}
      </mat-error>
      <mat-error *ngIf="control.hasError('endDate')">
        {{ 'end-date' | translate | sentancecase }}
      </mat-error>
      <mat-error *ngIf="control.hasError('startDate')">
        {{ 'start-date' | translate | sentancecase }}
      </mat-error>

      <mat-error *ngIf="control.hasError('matDatepickerMin')">
        {{ 'date-min-error' | translate | sentancecase }}
      </mat-error>

      <mat-error *ngIf="control.hasError('matDatepickerMax')">
        {{ 'date-max-error' | translate | sentancecase }}
      </mat-error>
    </mat-form-field>
  `,
  styleUrls: ['./date-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DatePickerComponent implements OnInit {
  @Input() control: FormControl;
  @Input() minDate: Date;
  @Input() maxDate: Date;
  @Input() label: string;

  constructor() {}

  ngOnInit() {}

  get isRequired(): boolean {
    if (this.control.validator) {
      const validator = this.control.validator({} as AbstractControl);
      if (validator && validator.required) {
        return true;
      }
    }

    return false;
  }
}
